import { LlmConversation } from '@adaptiva/ai/common';
import { SummarizableClassRegistration } from '@adaptiva/core/summary';
import { ActionServerObject, AdaptivaContent, AdaptivaPackage, Administrator, ClassLevelPermissions, ClassPermissionsDefinition, ClientSettingsServerPolicy, ClientTrustedCertificate, ClientTrustedCertificatePolicy, ClientUpgradeSettings, ContentController, ContentPushServerPolicy, DataProvider, DeviceObject, Folder, FolderLevelPermissions, Form, Group, HealthCheckObject, InventoryPolicy, LaunchOnScheduleSettings, ObjectLevelPermissions, Office, OidcCertificateClient, OidcProvider, Policy, RestApiEndpoint, Role, SamlProvider, SCCM12DeviceCollection, SCCM12UserCollection, Schedule, ScheduledClientHealthPolicy, SensorActionExecutionPolicy, SensorServerObject, SMSCollection, SmsFolder, Tenant, Theme, UserDashboard, UserDashboardSubscription, VMWareContent, WebForm, Workflow, WorkflowRoutingRule } from '@adaptiva/data-service';
import { SurveyServerObject } from '@adaptiva/forms/common';
import { SCCMApplication, SCCMDeploymentType, SCCMTaskSequence, SMSBootImagePackage, SMSConnectedObjectWithContent, SMSDriverPackage, SMSOSImagePackage, SMSOSInstallPackage, SMSPackage, SMSSoftwareUpdate, SoftwareDeploymentPackage } from '@adaptiva/onesite/common';
import { ClientWorkflowExecutionPolicy, CustomToolObject, PowerShellCmdletObject, ServerWorkflowExecutionPolicy, WorkflowActivity } from '@adaptiva/workflows/common';

/**
 * @description List out all Summarizable classes of which this application
 * 	needs to be aware
 * @example `[Group.className, Group]`
 */

export const ADMIN_PORTAL_SUMMARIZABLE_CLASSES: SummarizableClassRegistration[] = [
	[ActionServerObject.className, ActionServerObject],
	[AdaptivaContent.className, AdaptivaContent],
	[AdaptivaPackage.className, AdaptivaPackage],
	[Administrator.className, Administrator],
	[ClassLevelPermissions.className, ClassLevelPermissions],
	[ClassPermissionsDefinition.className, ClassPermissionsDefinition],
	[ClientSettingsServerPolicy.className, ClientSettingsServerPolicy],
	[ClientUpgradeSettings.className, ClientUpgradeSettings],
	[ClientWorkflowExecutionPolicy.className, ClientWorkflowExecutionPolicy],
	[ClientTrustedCertificate.className, ClientTrustedCertificate],
	[ClientTrustedCertificatePolicy.className, ClientTrustedCertificatePolicy],
	[ContentController.className, ContentController],
	[ContentPushServerPolicy.className, ContentPushServerPolicy],
	[CustomToolObject.className, CustomToolObject],
	[DataProvider.className, DataProvider],
	[DeviceObject.className, DeviceObject],
	[Folder.className, Folder],
	[FolderLevelPermissions.className, FolderLevelPermissions],
	[Form.className, Form],
	[Group.className, Group],
	[HealthCheckObject.className, HealthCheckObject],
	[InventoryPolicy.className, InventoryPolicy],
	[LaunchOnScheduleSettings.className, LaunchOnScheduleSettings],
	[LlmConversation.className, LlmConversation],
	[ObjectLevelPermissions.className, ObjectLevelPermissions],
	[Office.className, Office],
	[OidcCertificateClient.className, OidcCertificateClient],
	[OidcProvider.className, OidcProvider],
	[Policy.className, Policy],
	[PowerShellCmdletObject.className, PowerShellCmdletObject],
	[RestApiEndpoint.className, RestApiEndpoint],
	[Role.className, Role],
	[SamlProvider.className, SamlProvider],
	[SCCM12DeviceCollection.className, SCCM12DeviceCollection],
	[SCCM12UserCollection.className, SCCM12UserCollection],
	[SCCMApplication.className, SCCMApplication],
	[SCCMDeploymentType.className, SCCMDeploymentType],
	[SCCMTaskSequence.className, SCCMTaskSequence],
	[Schedule.className, Schedule],
	[ScheduledClientHealthPolicy.className, ScheduledClientHealthPolicy],
	[SensorActionExecutionPolicy.className, SensorActionExecutionPolicy],
	[SensorServerObject.className, SensorServerObject],
	[ServerWorkflowExecutionPolicy.className, ServerWorkflowExecutionPolicy],
	[SMSBootImagePackage.className, SMSBootImagePackage],
	[SMSCollection.className, SMSCollection],
	[SMSConnectedObjectWithContent.className, SMSConnectedObjectWithContent],
	[SMSDriverPackage.className, SMSDriverPackage],
	[SmsFolder.className, SmsFolder],
	[SMSOSImagePackage.className, SMSOSImagePackage],
	[SMSOSInstallPackage.className, SMSOSInstallPackage],
	[SMSPackage.className, SMSPackage],
	[SMSSoftwareUpdate.className, SMSSoftwareUpdate],
	[SoftwareDeploymentPackage.className, SoftwareDeploymentPackage],
	[SurveyServerObject.className, SurveyServerObject],
	[Tenant.className, Tenant],
	[Theme.className, Theme],
	[UserDashboard.className, UserDashboard],
	[UserDashboardSubscription.className, UserDashboardSubscription],
	[VMWareContent.className, VMWareContent],
	[WebForm.className, WebForm],
	[Workflow.className, Workflow],
	[WorkflowActivity.className, WorkflowActivity],
	[WorkflowRoutingRule.className, WorkflowRoutingRule],
];
